/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ItineratorError, ItineratorForm, ItineratorFormList } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Forms<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Form
   * @name GetForms
   * @summary List all forms
   * @request GET:/forms
   * @secure
   */
  getForms = (params: RequestParams = {}) =>
    this.request<ItineratorFormList, ItineratorError>({
      path: `/forms`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Form
   * @name GetFormBySlug
   * @summary Find a form by slug
   * @request GET:/forms/{slug}
   * @secure
   */
  getFormBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorForm, ItineratorError>({
      path: `/forms/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
